import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";

import TextInput from "../../../Components/TextInput";
import { goToTop } from "../../../Components/goToTop";

import { Ripple } from "primereact/ripple";
import { Image } from 'primereact/image';
import { Toast } from 'primereact/toast';
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Dropdown, DropdownChangeEvent, DropdownProps } from 'primereact/dropdown';
import { confirmDialog } from 'primereact/confirmdialog';
import { Dialog } from 'primereact/dialog';
import { useAppDispatch, useAppSelector } from "../../../Controllers/hooks";
import { mapRoles, Role } from "../../../Controllers/Types/UserRoleInterface";
import { contactDeleteAPI, domClientProjectUpdateAPI, employeePersonalUpdateAPI, employeeRoleUpdateAPI, roleCreateAPI, roleDataGetAPI } from "../../../Api/ContactApi";
import { checkEmail, checkFileImage, checkPhoneNumber, checkText } from "../../../Utils/Validator";
import { fetchAllContactAfterEditClientDetails, fetchAllContactAfterEditDomClientDetails } from "../../../Controllers/Thunks/contactThunks";
import { useAuth } from "../../../Authentication/AuthContext";
import { baseURL } from "../../../Api/ApiConstant";
import { useSelector } from "react-redux";
import { RootState } from "../../../Controllers/Store";
import { hasPermission } from "../../../Controllers/Selectors/permissionsSelector";
import ErrorPage from "../../../Components/ErrorPage";
import EmailSearchDialog from "../EmailSearchDialog";


const ViewDomesticClientContact: React.FC = () => {
    const selectedDomClient = useAppSelector(state => state.contact.selectedDomClient);
    const dispatch = useAppDispatch()


    const toast = useRef<Toast>(null);
    const navigate = useNavigate();

    const [tab, setTab] = useState<'personal' | 'project' | 'role'>('personal');
    const [showError, setShowError] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [showAddData, setShowAddData] = useState<boolean>(false);
    const [showEditModal, setShowEditModal] = useState<boolean>(false);

    const sampleImage = 'https://mdbcdn.b-cdn.net/img/new/avatars/2.webp';

    /* Personal form variables */
    const [profileImage, setProfileImage] = useState<string | null>(sampleImage);
    const [imageFile, setImageFile] = useState<File | null>(null);
    const [firstName, setFirstName] = useState<string>('');
    const [lastName, setLastName] = useState<string>('');
    const [email, setEmail] = useState<string>('');
    const [mobile, setMobile] = useState<string>('');
    const [landline, setLandline] = useState<string>('');
    const [address, setAddress] = useState<string>('');
    const [city, setCity] = useState<string>('');
    const [postCode, setPostCode] = useState<string>('');

    /* PERSONAL ERROR */
    const [firstNameError, setFirstNameError] = useState<string>('');
    const [lastNameError, setLastNameError] = useState<string>('');
    const [emailError, setEmailError] = useState<string>('');
    const [mobileError, setMobileError] = useState<string>('');
    const [landlineError, setLandlineError] = useState<string>('');
    const [addressError, setAddressError] = useState<string>('');
    const [cityError, setCityError] = useState<string>('');
    const [postCodeError, setPostCodeError] = useState<string>('');
    const [errorProfileImageFile, setErrorProfileImageFile] = useState<string>('');


    /* Project form variables */
    const [projectAddress, setProjectAddress] = useState<string>('');
    const [projectCity, setProjectCity] = useState<string>('');
    const [projectPostCode, setProjectPostCode] = useState<string>('');

    /* Project form variables error */
    const [projectAddressError, setProjectAddressError] = useState<string>('');
    const [projectCityError, setProjectCityError] = useState<string>('');
    const [projectPostCodeError, setProjectPostCodeError] = useState<string>('');

    /* Role form variables */
    const [roleList, setRoleList] = useState<Role[]>([]);
    const [selectedRole, setSelectedRole] = useState<Role | null>(null);


    const [addRoleName, setAddRoleName] = useState<string>('');
    const [addRoleNameError, setAddRoleNameError] = useState<string>('');

    const [selectedRoleError, setSelectedRoleError] = useState<string>('');


    const [displayRoleName, setDisplayRoleName] = useState<string>('');
    const [displayRoleNameError, setDisplayRoleNameError] = useState<string>('');
    const [displayRoleCommonError, setDisplayRoleCommonError] = useState<string>('');

    const [showSearchDomClientEmailModal, setShowSearchDomClientEmailModal] = useState<boolean>(false);


    const useCanEdit = (screen: string, permission: string) => {
        return useSelector((state: RootState) => hasPermission(state, screen, permission));
    };

    const isPermissionAdd = useCanEdit('Contact', 'add')
    const isPermissionUpdate = useCanEdit('Contact', 'update')
    const isPermissionDelete = useCanEdit('Contact', 'delete')

    const [isDefaultProfileImage, setIsDefaultProfileImage] = useState<boolean>(false);

    //For image upload/change
    const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files[0]) {
            const reader = new FileReader();
            reader.onload = (event: ProgressEvent<FileReader>) => {
                if (event.target && typeof event.target.result === 'string') {
                    setProfileImage(event.target.result);
                    const file = e.target.files?.[0];
                    setImageFile(file!);
                }
            };
            reader.readAsDataURL(e.target.files[0]);
        }
    };
    // 

    // For clear image
    const clearImage = () => {
        setProfileImage(null);
        setImageFile(null);
    };
    //

    /**************************************************** */
    function checkCredentials(): boolean {
        const isFirstNameValid = checkText(firstName, true, setFirstNameError)
        const isLastNameValid = checkText(lastName, true, setLastNameError)
        const isEmailValid = checkEmail(email, true, setEmailError)
        const isMobileValid = checkPhoneNumber(mobile, true, setMobileError)
        const isLandlineValid = checkPhoneNumber(landline, false, setLandlineError)
        const isAddressValid = checkText(address, true, setAddressError)
        const isCityValid = checkText(city, true, setCityError)
        const isPostCodeValid = checkText(postCode, true, setPostCodeError)
        const isFileValid = checkFileImage(imageFile!, false, setErrorProfileImageFile);


        return isFirstNameValid && isLastNameValid && isEmailValid && isMobileValid && isAddressValid && isCityValid && isPostCodeValid && isLandlineValid && isFileValid;
    }

    function showAPIErrorPersonalData(keyName: string, error: string): void {

        if (keyName === "email") {
            setEmailError(error);
        }
        if (keyName === "mobile") {
            setMobileError(error);
        }
        if (keyName === "landline") {
            setLandlineError(error);
        }
        if (keyName === "profile_image") {
            setErrorProfileImageFile(error);
        }
    }

    function clearAllErrorMassage() {
        setEmailError('');
        setMobileError('');
        setLandlineError('');
        setProjectAddressError('');
        setProjectCityError('');
        setProjectPostCodeError('');
        setDisplayRoleCommonError('');
        setErrorProfileImageFile('');
    }

    /****************************** For Update Personal Details ******************************/
    const handleUpdatePersonalDetails = async (e: React.FormEvent) => {
        e.preventDefault();

        clearAllErrorMassage();

        if (checkCredentials()) {
            setLoading(true)
            const res = await employeePersonalUpdateAPI(selectedDomClient!.id, firstName, lastName, email, mobile, landline, address, city, postCode, imageFile!);
            setLoading(false)
            if (res.status) {

                if (toast.current) {
                    toast.current.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Personal details updated successfully.',
                        life: 2000
                    });
                }

                dispatch(fetchAllContactAfterEditDomClientDetails());

                setShowEditModal(false);
                clearImage();
            } else {
                if (res.statusCode === 422) {
                    Object.entries(res.errors ?? []).map(([key, value], index) => (
                        showAPIErrorPersonalData(key, value[0])
                    ))
                }
            }

        }
    }
    /***************************************************************************************/

    function checkCredentialsProject(): boolean {
        const isProjectAddressValid = checkText(projectAddress, true, setProjectAddressError);
        const isProjectCityValid = checkText(projectCity, true, setProjectCityError);
        const isProjectPostCodeValid = checkText(projectPostCode, true, setProjectPostCodeError);

        return isProjectAddressValid && isProjectCityValid && isProjectPostCodeValid;
    }

    function showAPIErrorCompanyData(keyName: string, error: string): void {

        if (keyName === "address") {
            setProjectAddressError(error);
        }
        if (keyName === "city") {
            setProjectCityError(error);
        }
        if (keyName === "post_code") {
            setProjectPostCodeError(error);
        }
    }


    /****************************** For Update Project Details  ******************************/
    const handleUpdateProjectDetails = async (e: React.FormEvent) => {
        e.preventDefault();

        clearAllErrorMassage();

        if (checkCredentialsProject()) {
            setLoading(true);
            const data = await domClientProjectUpdateAPI(selectedDomClient?.domProjectId!, projectAddress, projectCity, projectPostCode);

            setLoading(false);

            if (!data.status) { // false
                if (data.statusCode === 422) {
                    Object.entries(data.errors ?? []).map(([key, value], index) => (
                        showAPIErrorCompanyData(key, value[0])
                    ))
                }
            } else {

                if (toast.current) {
                    toast.current.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Project details updated successfully.',
                        life: 3000
                    });
                }

                dispatch(fetchAllContactAfterEditDomClientDetails());

                setShowEditModal(false);

            }

        }
    }
    /***************************************************************************************/
    function checkCredentialsRole(): boolean {

        let isSelectedRoleValid: boolean = false

        if (selectedRole !== undefined) {
            isSelectedRoleValid = true;
            setSelectedRoleError('')
        } else {
            setSelectedRoleError('This field is required.')
        }

        const isDisplayRoleNameValid = checkText(displayRoleName, true, setDisplayRoleNameError)


        return isSelectedRoleValid && isDisplayRoleNameValid;
    }


    /****************************** For Update Role Details  ******************************/
    const handleUpdateRoleDetails = async (e: React.FormEvent) => {
        e.preventDefault();

        clearAllErrorMassage();

        if (checkCredentialsRole()) {
            setLoading(true);
            const res = await employeeRoleUpdateAPI(selectedDomClient!.user_role_info_id, selectedRole!.id, displayRoleName);
            setLoading(false);

            if (res.status) {

                dispatch(fetchAllContactAfterEditDomClientDetails());

                if (toast.current) {
                    toast.current.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Role details updated successfully.',
                        life: 3000
                    });
                }

                setTimeout(() => {
                    setShowEditModal(false);
                }, 500);

            } else {
                if (res.statusCode === 422) {
                    Object.entries(res.errors ?? []).map(([key, value], index) => (
                        setDisplayRoleCommonError(value[0])
                    ))
                }
            }

        }
    }
    /***************************************************************************************/


    /********************************* for Delete contact *********************************/
    const handleDeleteContact = async (e: React.FormEvent) => {
        confirmDialog({
            message: 'Are you sure you want to delete the domestic client details?',
            header: 'Confirm the deletion',
            icon: 'bi bi-info-circle',
            defaultFocus: 'accept',
            acceptClassName: 'p-button-danger',
            accept: deleteContact,
        });
    };

    const deleteContact = async () => {
        const res = await contactDeleteAPI(selectedDomClient!.contactId);

        if (res.status) {

            if (toast.current) {
                toast.current.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'Domestic Client deleted successfully.',
                    life: 3000
                });
            }

            setShowEditModal(false);

            setTimeout(() => {
                goBack()
            }, 500);



        } else {
            if (res.statusCode === 422) {
                if (toast.current) {
                    toast.current.show({
                        severity: 'error',
                        summary: 'Failed',
                        detail: 'Commercial Client deleted failed.',
                        life: 3000
                    });
                }
            }
        }
    }
    /***************************************************************************************/


    /************************************* For Role ************************************/
    // For showing selected role
    const selectedRoleTemplate = (option: Role, props: DropdownProps) => {
        if (option) {
            return (
                <div className="d-flex align-items-center">
                    <div>{option.role_name}</div>
                </div>
            );
        }

        return <span>{props.placeholder}</span>;
    };

    // For showing role options in the dropdown list
    const roleOptionTemplate = (option: Role) => {
        return (
            <div className="d-flex align-items-center">
                <div>{option.role_name}</div>
            </div>
        );
    };

    function checkCredentialsRoleCreate(roleName: string): boolean {
        const isRoleNameValid = checkText(roleName, true, setAddRoleNameError);

        return isRoleNameValid;
    }

    // For create custom role
    const handleAddRole = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentialsRoleCreate(addRoleName)) {
            const data = await roleCreateAPI(addRoleName, localStorage.getItem('token') || '');

            if (!data.status) { // false
                if (data.statusCode === 422) {
                    Object.entries(data.errors ?? []).map(([key, value], index) => (
                        setAddRoleNameError(value[0])
                    ))
                }
            } else {
                /* clear data */
                setAddRoleName('');
                setShowAddData(false)
                /* call call data function */
                roleDataGet();

                if (toast.current) {
                    toast.current.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Role created successfully.',
                        life: 3000
                    });
                }
            }
        }
    };
    /***************************************************************************************/


    const switchTabs = (tab: 'personal' | 'project' | 'role') => {
        setTab(tab);
    };

    const goBack = () => {
        navigate(-1);
        goToTop();
    }

    const [minHeight, setMinHeight] = useState<string>('0px');

    const calculateMinHeight = () => {
        const windowHeight = window.innerHeight;
        const distanceFromBottom = 200;
        const calculatedHeight = windowHeight - distanceFromBottom;
        setMinHeight(`${calculatedHeight}px`);
    };

    const toggleAddData = () => {
        setShowAddData(!showAddData);
    };

    const roleDataGet = async () => {

        const data = await roleDataGetAPI(localStorage.getItem('token') || '');
        if (data.status) {
            setRoleList(mapRoles(data.data || []) || []);
        }
    }

    useEffect(() => {
        roleDataGet();

        calculateMinHeight();
        window.addEventListener('resize', calculateMinHeight);

        return () => {
            window.removeEventListener('resize', calculateMinHeight);
        };
    }, []);



    useEffect(() => {
        setFirstName(selectedDomClient?.first_name!)
        setProfileImage(baseURL + selectedDomClient?.profile_image!)
        setLastName(selectedDomClient?.last_name!)
        setEmail(selectedDomClient?.email!)
        setMobile(selectedDomClient?.mobile!)
        setLandline(selectedDomClient?.landline!)
        setAddress(selectedDomClient?.address!)
        setCity(selectedDomClient?.city!)
        setPostCode(selectedDomClient?.post_code!)

        setProjectAddress(selectedDomClient?.domProjectAddress!)
        setProjectCity(selectedDomClient?.domProjectCity!)
        setProjectPostCode(selectedDomClient?.domProjectPostCode!)

        setSelectedRole({ id: selectedDomClient?.user_role_id!, role_name: selectedDomClient?.role_name! })
        setDisplayRoleName(selectedDomClient?.display_role_name!)

        if (selectedDomClient && selectedDomClient?.profile_image) {
            const fileName = selectedDomClient?.profile_image.split('/').pop();

            if (fileName === 'user.png') {
                setIsDefaultProfileImage(true);
            } else {
                setIsDefaultProfileImage(false);
            }
        } else {
            setIsDefaultProfileImage(false);
        }
    }, [selectedDomClient]);


    /* Edit modal component */
    const editModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                {tab === 'personal' ?
                    "Edit Personal detail" :
                    tab === 'project' ?
                        "Edit Project detail" :
                        tab === 'role' ?
                            "Edit Role detail" :
                            null
                }
            </h5>
            {isPermissionDelete && <button type="button" className="data_delete_btn p-ripple"
                onClick={handleDeleteContact}>
                <i className="bi bi-trash3"></i>
                <Ripple />
            </button>}
        </div>
    );

    const editModalFooter = (
        <div className="custom_modal_footer">
            <Button label="Close" className="custom_btn secondary" onClick={() => setShowEditModal(false)} />
            {tab === 'personal' ?
                (<Button label={`${loading ? 'Updating' : 'Update'}`} onClick={handleUpdatePersonalDetails} loading={loading} className="custom_btn primary" />) :
                tab === 'project' ?
                    (<Button label={`${loading ? 'Updating' : 'Update'}`} onClick={handleUpdateProjectDetails} loading={loading} className="custom_btn primary" />) :
                    tab === 'role' ?
                        (<Button label={`${loading ? 'Updating' : 'Update'}`} onClick={handleUpdateRoleDetails} loading={loading} className="custom_btn primary" />) :
                        null
            }
        </div>
    );

    const onEmailConfirmDomClient = (email: string) => {
        setEmail(email);
    }

    /* */

    /* Clear validation messages */
    // Personal
    useEffect(() => {
        checkText(firstName, false, setFirstNameError);
    }, [firstName]);

    useEffect(() => {
        checkText(lastName, false, setLastNameError);
    }, [lastName]);

    useEffect(() => {
        checkEmail(email, false, setEmailError);
    }, [email]);

    useEffect(() => {
        checkPhoneNumber(mobile, false, setMobileError);
    }, [mobile]);

    useEffect(() => {
        checkPhoneNumber(landline, false, setLandlineError);
    }, [landline]);

    useEffect(() => {
        checkText(address, false, setAddressError);
    }, [address]);

    useEffect(() => {
        checkText(city, false, setCityError);
    }, [city]);

    useEffect(() => {
        checkText(postCode, false, setPostCodeError);
    }, [postCode]);

    useEffect(() => {
        checkFileImage(imageFile!, false, setErrorProfileImageFile);
    }, [imageFile]);
    // 

    // Project
    useEffect(() => {
        checkText(projectAddress, false, setProjectAddressError);
    }, [projectAddress]);

    useEffect(() => {
        checkText(projectCity, false, setProjectCityError);
    }, [projectCity]);

    useEffect(() => {
        checkText(projectPostCode, false, setProjectPostCodeError);
    }, [projectPostCode]);

    // Role
    useEffect(() => {
        if (selectedRole !== null && selectedRole !== undefined) {
            setSelectedRoleError('');
        }
    }, [selectedRole]);

    useEffect(() => {
        checkText(displayRoleName, false, setDisplayRoleNameError);
    }, [displayRoleName]);

    useEffect(() => {
        checkText(addRoleName, false, setAddRoleNameError);
    }, [addRoleName]);
    // 

    return (
        <React.Fragment>
            <Toast ref={toast} />

            <div className="main_content layout_padding show_side_bar">
                {(!selectedDomClient) ? (
                    <ErrorPage
                        errorMessage="There was an error retrieving the selected client details."
                    />
                ) : (
                    <React.Fragment>
                        <div className="main_head_area">
                            <h4 className="main_heading">View Contact</h4>

                            <button className="back_btn p-ripple" onClick={goBack}>
                                <i className="bi bi-arrow-left me-2"></i>
                                Back
                                <Ripple />
                            </button>
                        </div>

                        <div className="page_label_area">
                            <h6>Domestic Client</h6>
                        </div>

                        <div className="page_content mt-0">
                            <div className="page_body_area mt-3">
                                <div className="row">
                                    <div className="col-12 col-xl-4 mx-auto page_divider custom_height" style={{ minHeight }}>
                                        <div className="profile_view_area mt-2 mt-sm-0 mb-4 mb-sm-0">
                                            <div className="profile_view_main_area">
                                                <Image
                                                    className="profile_img_area"
                                                    src={baseURL + selectedDomClient?.profile_image}
                                                    alt="Profile"
                                                    preview={!isDefaultProfileImage}
                                                />

                                                <h5 className="profile_name text_purple">
                                                    {(selectedDomClient?.first_name || selectedDomClient?.last_name)
                                                        ? `${selectedDomClient?.first_name ?? ''} ${selectedDomClient?.last_name ?? ''}`.trim()
                                                        : ''
                                                    }
                                                </h5>
                                                <h6 className="profile_role">{selectedDomClient?.contactSubType}</h6>
                                            </div>

                                            <div className="profile_view_tab_area">
                                                <div className="profile_view_tabs" id="profileViewTab" role="tablist" aria-orientation="vertical">
                                                    <button
                                                        className={`profile_view_tab_btn p-ripple ${tab === 'personal' ? 'active' : ''}`}
                                                        onClick={() => switchTabs('personal')}
                                                        id="personal-detail-tab"
                                                        data-bs-toggle="pill"
                                                        data-bs-target="#personal-detail"
                                                        type="button"
                                                        role="tab"
                                                        aria-controls="personal-detail"
                                                        aria-selected={tab === 'personal'}
                                                    >
                                                        Personal
                                                        <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                                    </button>

                                                    <button
                                                        className={`profile_view_tab_btn p-ripple ${tab === 'project' ? 'active' : ''}`}
                                                        onClick={() => switchTabs('project')}
                                                        id="project-detail-tab"
                                                        data-bs-toggle="pill"
                                                        data-bs-target="#project-detail"
                                                        type="button"
                                                        role="tab"
                                                        aria-controls="project-detail"
                                                        aria-selected={tab === 'project'}
                                                    >
                                                        Project
                                                        <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                                    </button>

                                                    <button
                                                        className={`profile_view_tab_btn p-ripple ${tab === 'role' ? 'active' : ''}`}
                                                        onClick={() => switchTabs('role')}
                                                        id="role-detail-tab"
                                                        data-bs-toggle="pill"
                                                        data-bs-target="#role-detail"
                                                        type="button"
                                                        role="tab"
                                                        aria-controls="role-detail"
                                                        aria-selected={tab === 'role'}
                                                    >
                                                        Role
                                                        <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-12 col-xl-8">
                                        <div className="profile_view_area">
                                            {isPermissionUpdate && <button className="profile_edit_btn main p-ripple" onClick={() => setShowEditModal(true)}>
                                                <i className="bi bi-pencil-square"></i>
                                                <Ripple />
                                            </button>}
                                            <div className="tab-content profile_view_tab_content" id="profileViewTabContent">
                                                {/* Personal Details */}
                                                <div className={`tab-pane profile_view_tab_panel fade ${tab === 'personal' ? 'show active' : ''}`} id="personal-detail" role="tabpanel" aria-labelledby="personal-detail-tab" tabIndex={0}>
                                                    <div className="row">
                                                        {/* First name */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">First name</label>
                                                                <div className="form_data_view_box">
                                                                    {selectedDomClient?.first_name ? (
                                                                        <p>{selectedDomClient?.first_name}</p>
                                                                    ) : (
                                                                        <span className="placeholder_text">First name</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Last name */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">Last name</label>
                                                                <div className="form_data_view_box">
                                                                    {selectedDomClient?.last_name ? (
                                                                        <p>{selectedDomClient?.last_name}</p>
                                                                    ) : (
                                                                        <span className="placeholder_text">Last name</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Email */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">Email</label>
                                                                <div className="form_data_view_box">
                                                                    {selectedDomClient?.email ? (
                                                                        <Link
                                                                            to={`mailto:${selectedDomClient?.email}`}
                                                                            className="text_no_wrap is_link is_contact_element mail">
                                                                            {selectedDomClient?.email}
                                                                        </Link>
                                                                    ) : (
                                                                        <span className="placeholder_text">Email</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Mobile */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">Mobile</label>
                                                                <div className="form_data_view_box">
                                                                    {selectedDomClient?.mobile ? (
                                                                        <Link
                                                                            to={`tel:${selectedDomClient?.mobile}`}
                                                                            className="text_no_wrap is_link is_contact_element phone">
                                                                            {selectedDomClient?.mobile}
                                                                        </Link>
                                                                    ) : (
                                                                        <span className="placeholder_text">Mobile</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Landline */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">Landline</label>
                                                                <div className="form_data_view_box">
                                                                    {selectedDomClient?.landline ? (
                                                                        <Link
                                                                            to={`tel:${selectedDomClient?.landline}`}
                                                                            className="text_no_wrap is_link is_contact_element phone">
                                                                            {selectedDomClient?.landline}
                                                                        </Link>
                                                                    ) : (
                                                                        <span className="placeholder_text">Landline</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Address */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">Address</label>
                                                                <div className="form_data_view_box">
                                                                    {selectedDomClient?.address ? (
                                                                        <p>{selectedDomClient?.address}</p>
                                                                    ) : (
                                                                        <span className="placeholder_text">Address</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* City */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">City</label>
                                                                <div className="form_data_view_box">
                                                                    {selectedDomClient?.city ? (
                                                                        <p>{selectedDomClient?.city}</p>
                                                                    ) : (
                                                                        <span className="placeholder_text">City</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Post code */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">Post code</label>
                                                                <div className="form_data_view_box">
                                                                    {selectedDomClient?.post_code ? (
                                                                        <p>{selectedDomClient?.post_code}</p>
                                                                    ) : (
                                                                        <span className="placeholder_text">Post code</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Project Details */}
                                                <div className={`tab-pane profile_view_tab_panel fade ${tab === 'project' ? 'show active' : ''}`} id="project-detail" role="tabpanel" aria-labelledby="project-detail-tab" tabIndex={0}>
                                                    <div className="row">
                                                        {/* Address */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">Address</label>
                                                                <div className="form_data_view_box">
                                                                    {selectedDomClient?.domProjectAddress ? (
                                                                        <p>{selectedDomClient?.domProjectAddress}</p>
                                                                    ) : (
                                                                        <span className="placeholder_text">Address</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* City */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">City</label>
                                                                <div className="form_data_view_box">
                                                                    {selectedDomClient?.domProjectCity ? (
                                                                        <p>{selectedDomClient?.domProjectCity}</p>
                                                                    ) : (
                                                                        <span className="placeholder_text">City</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Post code */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">Post code</label>
                                                                <div className="form_data_view_box">
                                                                    {selectedDomClient?.domProjectPostCode ? (
                                                                        <p>{selectedDomClient?.domProjectPostCode}</p>
                                                                    ) : (
                                                                        <span className="placeholder_text">Post code</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Role Details */}
                                                <div className={`tab-pane profile_view_tab_panel fade ${tab === 'role' ? 'show active' : ''}`} id="role-detail" role="tabpanel" aria-labelledby="role-detail-tab" tabIndex={0}>
                                                    <div className="row">
                                                        {/* Role name */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">Role name</label>
                                                                <div className="form_data_view_box">
                                                                    {selectedDomClient?.role_name ? (
                                                                        <p>{selectedDomClient?.role_name}</p>
                                                                    ) : (
                                                                        <span className="placeholder_text">Role name</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Display role name */}
                                                        <div className="col-12 col-xl-6 col-sm-6">
                                                            <div className="page_form_group">
                                                                <label className="custom_form_label">Display role name</label>
                                                                <div className="form_data_view_box">
                                                                    {selectedDomClient?.display_role_name ? (
                                                                        <p>{selectedDomClient?.display_role_name}</p>
                                                                    ) : (
                                                                        <span className="placeholder_text">Display role name</span>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </React.Fragment>
                )}

                {/* Contact edit modal */}
                <Dialog header={editModalHeader} headerClassName="custom_modal_header"
                    footer={editModalFooter} visible={showEditModal}
                    className="custom_modal_dialog modal_dialog_lg" onHide={() => { if (!showEditModal) return; setShowEditModal(false); }}>
                    <div className="custom_modal_body custom">
                        <div className="row">
                            <div className="col-12 col-xl-4 page_divider">
                                <div className="profile_edit_area">

                                    {tab === 'personal' ? (
                                        <React.Fragment>
                                            <div className="form_img_upload_area pt-0">
                                                <div className="form_img_upload">
                                                    <input
                                                        type="file"
                                                        accept="image/*"
                                                        className="form_img_upload_input"
                                                        id="profileImage"
                                                        onChange={handleImageChange}
                                                    />
                                                    <div className="form_img_upload_label_area">
                                                        <label
                                                            htmlFor="profileImage"
                                                            className={`form_img_upload_label ${profileImage ? 'uploaded' : ''}`}
                                                            style={{ backgroundImage: profileImage ? `url(${profileImage})` : selectedDomClient?.profile_image ? `url(${baseURL + selectedDomClient?.profile_image})` : '' }}
                                                        >
                                                            {(!profileImage && selectedDomClient?.profile_image === null) && (
                                                                <div className="upload_icon">
                                                                    <i className="bi bi-camera-fill"></i>
                                                                </div>
                                                            )}
                                                        </label>

                                                        {(profileImage || selectedDomClient?.profile_image) && (
                                                            <label htmlFor="profileImage" className="upload_update_icon">
                                                                <i className="bi bi-camera-fill"></i>
                                                            </label>
                                                        )}
                                                    </div>
                                                    {profileImage ? (
                                                        <React.Fragment>
                                                            <label htmlFor="profileImage" className="add_image_label mt-2">Change image</label>
                                                            {imageFile && (
                                                                <button className="upload_clear_button mt-2" onClick={clearImage}>Remove</button>
                                                            )}
                                                        </React.Fragment>
                                                    ) : selectedDomClient?.profile_image ? (
                                                        <label htmlFor="profileImage" className="add_image_label mt-2">Change image</label>
                                                    ) : (
                                                        <label htmlFor="profileImage" className="add_image_label mt-2">Add image</label>
                                                    )}
                                                </div>
                                            </div>

                                            {errorProfileImageFile !== '' && (
                                                <small className="form_error_msg text-center mt-2">{errorProfileImageFile}</small>
                                            )}
                                        </React.Fragment>
                                    ) : (
                                        <div className="profile_view_main_area mb-4">
                                            <Image
                                                className="profile_img_area custom"
                                                src={`${baseURL}${selectedDomClient?.profile_image}`}
                                                alt="Profile"
                                                preview={!isDefaultProfileImage}
                                            />

                                            <h5 className="profile_name text_purple">
                                                {(selectedDomClient?.first_name || selectedDomClient?.last_name)
                                                    ? `${selectedDomClient?.first_name ?? ''} ${selectedDomClient?.last_name ?? ''}`.trim()
                                                    : ''
                                                }
                                            </h5>
                                            <h6 className="profile_role">{selectedDomClient?.role_name}</h6>
                                        </div>
                                    )}

                                    <div className="profile_edit_tab_area">
                                        <div className="profile_view_tabs" id="profileEditTab" role="tablist" aria-orientation="vertical">
                                            <button
                                                className={`profile_view_tab_btn p-ripple ${tab === 'personal' ? 'active' : ''}`}
                                                onClick={() => switchTabs('personal')}
                                                id="personal-edit-detail-tab"
                                                data-bs-toggle="pill"
                                                data-bs-target="#personal-edit-detail"
                                                type="button"
                                                role="tab"
                                                aria-controls="personal-edit-detail"
                                                aria-selected={tab === 'personal'}
                                            >
                                                Personal
                                                <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                            </button>

                                            <button
                                                className={`profile_view_tab_btn p-ripple ${tab === 'project' ? 'active' : ''}`}
                                                onClick={() => switchTabs('project')}
                                                id="project-edit-detail-tab"
                                                data-bs-toggle="pill"
                                                data-bs-target="#project-edit-detail"
                                                type="button"
                                                role="tab"
                                                aria-controls="project-edit-detail"
                                                aria-selected={tab === 'project'}
                                            >
                                                Project
                                                <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                            </button>

                                            <button
                                                className={`profile_view_tab_btn p-ripple ${tab === 'role' ? 'active' : ''}`}
                                                onClick={() => switchTabs('role')}
                                                id="role-edit-detail-tab"
                                                data-bs-toggle="pill"
                                                data-bs-target="#role-edit-detail"
                                                type="button"
                                                role="tab"
                                                aria-controls="role-edit-detail"
                                                aria-selected={tab === 'role'}
                                            >
                                                Role
                                                <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 col-xl-8">
                                <div className="profile_edit_area edit_form h-100">
                                    <div className="tab-content profile_view_tab_content" id="profileEditTabContent">
                                        {/* Edit Personal detail */}
                                        <div className={`tab-pane profile_view_tab_panel p-0 fade ${tab === 'personal' ? 'show active' : ''}`}
                                            id="personal-edit-detail" role="tabpanel" aria-labelledby="personal-edit-detail-tab" tabIndex={0}>
                                            <div className="row">
                                                {/* First name */}
                                                <div className="col-12 col-xl-6 col-sm-6">
                                                    <TextInput
                                                        id="firstName"
                                                        label="First name"
                                                        labelHtmlFor="firstName"
                                                        required={true}
                                                        value={firstName}
                                                        placeholder="First name"
                                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFirstName(e.target.value)}
                                                        error={firstNameError}
                                                    />
                                                </div>

                                                {/* Last name */}
                                                <div className="col-12 col-xl-6 col-sm-6">
                                                    <TextInput
                                                        id="lastName"
                                                        label="Last name"
                                                        labelHtmlFor="lastName"
                                                        required={true}
                                                        value={lastName}
                                                        placeholder="Last name"
                                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setLastName(e.target.value)}
                                                        error={lastNameError}
                                                    />
                                                </div>

                                                {/* Email */}
                                                <div className="col-12 col-xl-6 col-sm-6">
                                                    <div className="page_form_group">
                                                        <label htmlFor="email" className="custom_form_label is_required">Email</label>

                                                        <div className="input_search_group">
                                                            <InputText
                                                                id="email"
                                                                value={email}
                                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
                                                                className="custom_form_input"
                                                                placeholder="Email"
                                                                disabled
                                                            />

                                                            {!email ? (
                                                                <button
                                                                    className="input_grp_btn primary pos_abs p-ripple"
                                                                    onClick={() => setShowSearchDomClientEmailModal(true)}>
                                                                    <i className="bi bi-search"></i>
                                                                    <Ripple />
                                                                </button>
                                                            ) : (
                                                                <button
                                                                    className="input_grp_btn danger pos_abs p-ripple"
                                                                    onClick={() => setEmail('')}>
                                                                    <i className="bi bi-x-lg"></i>
                                                                    <Ripple />
                                                                </button>
                                                            )}
                                                        </div>
                                                        {emailError &&
                                                            <small className="form_error_msg">{emailError}</small>
                                                        }
                                                    </div>
                                                </div>

                                                {/* Mobile */}
                                                <div className="col-12 col-xl-6 col-sm-6">
                                                    <TextInput
                                                        id="mobile"
                                                        label="Mobile"
                                                        labelHtmlFor="mobile"
                                                        required={true}
                                                        value={mobile}
                                                        placeholder="Mobile"
                                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setMobile(e.target.value)}
                                                        error={mobileError}
                                                    />
                                                </div>

                                                {/* Landline */}
                                                <div className="col-12 col-xl-6 col-sm-6">
                                                    <TextInput
                                                        id="landline"
                                                        label="Landline"
                                                        labelHtmlFor="landline"
                                                        required={false}
                                                        value={landline}
                                                        placeholder="Landline"
                                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setLandline(e.target.value)}
                                                        error={landlineError}
                                                    />
                                                </div>

                                                {/* Address */}
                                                <div className="col-12 col-xl-6 col-sm-6">
                                                    <TextInput
                                                        id="address"
                                                        label="Address"
                                                        labelHtmlFor="address"
                                                        required={true}
                                                        value={address}
                                                        placeholder="Address"
                                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setAddress(e.target.value)}
                                                        error={addressError}
                                                    />
                                                </div>

                                                {/* City */}
                                                <div className="col-12 col-xl-6 col-sm-6">
                                                    <TextInput
                                                        id="city"
                                                        label="City"
                                                        labelHtmlFor="city"
                                                        required={true}
                                                        value={city}
                                                        placeholder="City"
                                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCity(e.target.value)}
                                                        error={cityError}
                                                    />
                                                </div>

                                                {/* Post code */}
                                                <div className="col-12 col-xl-6 col-sm-6">
                                                    <TextInput
                                                        id="postCode"
                                                        label="Post code"
                                                        labelHtmlFor="postCode"
                                                        required={true}
                                                        value={postCode}
                                                        placeholder="Post code"
                                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPostCode(e.target.value)}
                                                        error={postCodeError}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        {/* Edit Project detail */}
                                        <div className={`tab-pane profile_view_tab_panel p-0 fade ${tab === 'project' ? 'show active' : ''}`}
                                            id="project-edit-detail" role="tabpanel" aria-labelledby="project-edit-detail-tab" tabIndex={0}>
                                            <div className="row">
                                                {/* Address */}
                                                <div className="col-12 col-xl-6 col-sm-6">
                                                    <TextInput
                                                        id="projectAddress"
                                                        label="Address"
                                                        labelHtmlFor="projectAddress"
                                                        required={true}
                                                        value={projectAddress}
                                                        placeholder="Address"
                                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setProjectAddress(e.target.value)}
                                                        error={projectAddressError}
                                                    />
                                                </div>

                                                {/* City */}
                                                <div className="col-12 col-xl-6 col-sm-6">
                                                    <TextInput
                                                        id="projectCity"
                                                        label="City"
                                                        labelHtmlFor="projectCity"
                                                        required={true}
                                                        value={projectCity}
                                                        placeholder="City"
                                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setProjectCity(e.target.value)}
                                                        error={projectCityError}
                                                    />
                                                </div>

                                                {/* Post code */}
                                                <div className="col-12 col-xl-6 col-sm-6">
                                                    <TextInput
                                                        id="projectPostCode"
                                                        label="Post code"
                                                        labelHtmlFor="projectPostCode"
                                                        required={true}
                                                        value={projectPostCode}
                                                        placeholder="Post code"
                                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setProjectPostCode(e.target.value)}
                                                        error={projectPostCodeError}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        {/* Edit Role detail */}
                                        <div className={`tab-pane profile_view_tab_panel p-0 fade ${tab === 'role' ? 'show active' : ''}`}
                                            id="role-edit-detail" role="tabpanel" aria-labelledby="role-edit-detail-tab" tabIndex={0}>
                                            <div className="row">
                                                {/* Role name */}
                                                <div className="col-12 col-xl-6 col-sm-6">
                                                    <div className="page_form_group">
                                                        <div className="w-100">
                                                            <label htmlFor="role" className="custom_form_label is_required">Role name</label>
                                                            <Dropdown
                                                                value={selectedRole}
                                                                id="role"
                                                                onChange={(e: DropdownChangeEvent) => setSelectedRole(e.value)}
                                                                options={roleList}
                                                                optionLabel="role_name"
                                                                valueTemplate={selectedRoleTemplate}
                                                                itemTemplate={roleOptionTemplate}
                                                                placeholder="Select role"
                                                                className="form_dropdown w-100"
                                                                showClear
                                                            />

                                                            {selectedRoleError !== '' &&
                                                                <small className="form_error_msg">{selectedRoleError}</small>
                                                            }
                                                        </div>

                                                        <div className="add_data_area">
                                                            {isPermissionAdd && <button className={`add_data_btn ${showAddData ? 'danger' : ''} p-ripple`} onClick={toggleAddData}>
                                                                <i className={`bi ${showAddData ? 'bi-dash-circle' : ' bi-plus-circle'}`}></i>
                                                                {showAddData ? (<span>Cancel</span>)
                                                                    : (<span>Add role</span>)
                                                                }
                                                                < Ripple />
                                                            </button>}

                                                            <div className={`add_data_input_area ${showAddData ? 'show' : ''}`}>
                                                                <InputText
                                                                    id="roleName"
                                                                    value={addRoleName}
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setAddRoleName(e.target.value)}
                                                                    className="custom_form_input"
                                                                    placeholder="Enter role name"
                                                                />

                                                                <Button
                                                                    label="Add"
                                                                    className="ps-4 pe-4"
                                                                    onClick={handleAddRole}
                                                                />
                                                            </div>
                                                            {addRoleNameError !== '' && (
                                                                <small className="form_error_msg">{addRoleNameError}</small>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Display role name */}
                                                <div className="col-12 col-xl-6 col-sm-6">
                                                    <TextInput
                                                        id="displayRoleName"
                                                        label="Display role name"
                                                        labelHtmlFor="displayRoleName"
                                                        required={true}
                                                        value={displayRoleName}
                                                        placeholder="Display role name"
                                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setDisplayRoleName(e.target.value)}
                                                        error={displayRoleNameError}
                                                    />
                                                </div>

                                                <div className="col-12">
                                                    <div className="form_btn_area justify-content-center">
                                                        {displayRoleCommonError !== '' &&
                                                            <small className="form_error_msg">{displayRoleCommonError}</small>
                                                        }
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Dialog>

                <EmailSearchDialog
                    visible={showSearchDomClientEmailModal}
                    contactSubtype="Domestic Client"
                    onHide={() => setShowSearchDomClientEmailModal(false)}
                    onEmailConfirm={(email) => onEmailConfirmDomClient(email)}
                />
                {/*  */}
            </div>
        </React.Fragment>
    )
}

export default ViewDomesticClientContact;